import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {
  TextField,
  Button,
  Alert,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

const CrearOpciones = ({ desplegableId }) => {
  const [opcion, setOpcion] = useState("");
  const [opciones, setOpciones] = useState([]);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState(false);

  const handleAddOpcion = async (e) => {
    e.preventDefault();

    const nuevaOpcion = {
      desplegableId,
      opcion,
    };

    try {
      // Enviar opción al backend
      await axios.post(
        "https://portaltransaccionalback.azurewebsites.net/api/CreaOpcion",
        nuevaOpcion
      );


      setOpciones((prevOpciones) => [
        ...prevOpciones,
        { id: prevOpciones.length + 1, opcion }, // Genera un ID ficticio para el frontend
      ]);

      Swal.fire({
              title: "Opción guardada",
              text: "Tu opción se guardo correctamente.",
              icon: "success",
              timer: 2000, // La alerta desaparece automáticamente después de 3 segundos
              showConfirmButton: false, // Oculta el botón de confirmación
            });
      setError(false);
      setOpcion(""); // Limpia el campo de texto
    } catch (error) {
      setMensaje("Error al agregar la opción");
      setError(true);
      console.error("Error en la solicitud:", error);
    }
  };

  return (
    <div style={{ marginTop: "16px" }}>
      <form
        onSubmit={handleAddOpcion}
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
      >
        <TextField
          label="Opción"
          variant="outlined"
          value={opcion}
          onChange={(e) => setOpcion(e.target.value)}
          required
        />
        <Button type="submit" variant="contained" color="primary">
          Agregar Opción
        </Button>
      </form>

      {mensaje && (
        <Alert
          severity={error ? "error" : "success"}
          style={{ marginTop: "16px" }}
        >
          {mensaje}
        </Alert>
      )}
      <Typography variant="body1" color="error">
      Agregue todas las opciones antes de cambiar el tipo de pregunta, una vez sea cambiado no podra volver a agregar.
      </Typography>
      <Typography variant="subtitle1" style={{ marginTop: "16px" }}>
        Opciones agregadas:
      </Typography>
      <List>
        {opciones.map((op, index) => (
          <ListItem key={index}>
            <ListItemText primary={op.opcion} />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default CrearOpciones;
